export const TAB_STANDARD_MEETING_PROTOCOL = "TAB_STANDARD_MEETING_PROTOCOL";
